const columnsActionsPrefix = "column-width";

export const columnWidthActions = {
  CHANGE_WIDTH: `${columnsActionsPrefix}/change-width`,
  RESET_COLUMN_WIDTH: `${columnsActionsPrefix}/reset-column-width`,
};
